export default __webpack_public_path__ + "media/zurb/img/case-study-iqtell/iqtell-wireframes-0dce833cfb2ecde480ec6e137caf0db3.png";